import React, { PureComponent } from "react";

import PropTypes from "prop-types";
import { UISref } from "@uirouter/react";
import classNames from "classnames";

class LinkDataCell extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    params: PropTypes.object,
    to: PropTypes.string,
    value: PropTypes.string
  };

  static defaultProps = {
    className: "",
    params: {},
    to: "",
    value: ""
  };
  render() {
    return (
      <UISref to={this.props.to} params={this.props.params}>
        <a className={classNames("data-grid__data --link", this.props.className)}>{this.props.value}</a>
      </UISref>
    );
  }
}

export default LinkDataCell;



// WEBPACK FOOTER //
// ./src/components/Layout/DataGrid/LinkDataCell.js